const { createContext } = require("react");

export const ReviewContext = createContext()